import { ECategory } from 'shared/types/offers';

export const getPaymentPeriod = (category: ECategory): string => {
  return category && category.indexOf('daily') !== -1 ? 'сутки' : 'мес.';
};
